import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestUsuariosFrentistas({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'usuariosfrentistas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteUsuarioFrentista({ payload }) {
  try {
    const { idusuario, params } = payload;

    yield call(api.delete, `usuariosfrentistas/${idusuario}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(t(e)));
    else toast.error(t(erros));
  }
}

export function* store({ payload }) {
  try {
    const { usuario, params } = payload;

    yield call(api.post, 'usuariosfrentistas', usuario);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/usuarios');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { idusuario } = payload;

    const { data } = yield call(api.get, `usuariosfrentistas/${idusuario}`);

    data.param5usuariooperador = JSON.stringify(data.param5usuariooperador);
    data.param7usuariooperador = JSON.stringify(data.param7usuariooperador);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { usuario, params } = payload;

    yield call(api.put, 'usuariosfrentistas', usuario);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/usuarios');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'usuariosfrentistas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest(
    '@usuariofrentista/USUARIOS_IN_REQUEST',
    requestUsuariosFrentistas
  ),
  takeLatest('@usuariofrentista/DELETE_USUARIO', deleteUsuarioFrentista),
  takeLatest('@usuariofrentista/SUCCESS_REMOVE', requestUsuariosFrentistas),
  takeLatest('@usuariofrentista/STORE_USUARIO', store),
  takeLatest('@usuariofrentista/FIND_USUARIO', find),
  takeLatest('@usuariofrentista/UPDATE_USUARIO', update),
  takeLatest('@usuariofrentista/RECORD_FILTERING', applyedFilters),
]);
